// Prestige builds facet URLs with FormData. Convert only at that boundary; UI stays in the buyer's price mode.
(() => {
  document.addEventListener('formdata', event => {
    if (window.mpPriceMode !== 'gross') return;
    const range = event.target.querySelector?.('price-range[data-mp-price-multiplier]');
    const multiplier = Number(range?.dataset.mpPriceMultiplier);
    if (!(multiplier > 1)) return;
    for (const name of ['filter.v.price.gte', 'filter.v.price.lte']) {
      const value = event.formData.get(name);
      if (value !== null && value !== '' && Number.isFinite(Number(value))) {
        // Invert half-up rounding at the boundary, so a maximum never admits a gross price one cent too high.
        const grossCents = Math.round(Number(value) * 100);
        const netCents = name.endsWith('.gte')
          ? Math.ceil((grossCents - 0.5) / multiplier - 1e-9)
          : Math.ceil((grossCents + 0.5) / multiplier - 1e-9) - 1;
        event.formData.set(name, (Math.max(0, netCents) / 100).toFixed(2));
      }
    }
  }, true);
})();
